import { useState } from 'react';
import { Icon } from '@sb1/ffe-icons-react';
import classNames from 'classnames';
import Image from '../../../components/image/Image';
import { useProject } from '../../project-hooks/useProject';
import { BodyText, Heading2 } from '@sb1/ffe-core-react';
import { ModalBlock } from '@sb1/ffe-modals-react';
import downloadIcon from '@sb1/ffe-icons/icons/open/300/md/download.svg';
import { PrimaryButton, SecondaryButton } from '@sb1/ffe-buttons-react';
import { triggerFileDownload } from '../../../utils';
import { Spinner } from '@sb1/ffe-spinner-react';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';
import styles from './shareOnProject.module.less';
import { useSelector } from 'react-redux';
import { isProjectPartOfTVA } from '../../project-model';

export const ImageModalContainer = ({
    onBack,
    trackingProperties,
    heading,
    subHeading,
    type,
    url,
    downloadText,
    imageBorder = false,
}) => {
    const project = useProject();
    const [loadingSharingImage, setLoadingSharingImage] = useState(true);

    return (
        <ModalBlock>
            <Heading2 id="share-modal-title">{heading}</Heading2>
            <BodyText>{subHeading}</BodyText>
            {loadingSharingImage && <Spinner />}
            <div className={[styles.photoContainer, loadingSharingImage ? styles.hidden : ''].join(' ')}>
                <Image
                    className={classNames(
                        styles.previewPhoto,
                        styles.imageShare,
                        imageBorder ? styles.photoBorder : ''
                    )}
                    src={url}
                    title={'Last ned og del'}
                    alt={heading}
                    onLoad={() => setLoadingSharingImage(false)}
                />
            </div>
            <div className={styles.downloadButtons}>
                {onBack && <SecondaryButton onClick={onBack}>Tilbake</SecondaryButton>}
                <PrimaryButton
                    leftIcon={<Icon fileUrl={downloadIcon} />}
                    onClick={() => {
                        trackEvent('project', `image-download-modal`, { channel: type, ...trackingProperties });
                        triggerFileDownload(url, `${project.id}-${type}`);
                    }}
                >
                    {downloadText}
                </PrimaryButton>
            </div>
        </ModalBlock>
    );
};
